import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { initializeSocket, closeSocket } from '../socket';

const useSocketService = () => {
    const { token } = useSelector((state) => state.auth);
    const socketInitialized = useRef(false);

    useEffect(() => {
        if (token && !socketInitialized.current) {
            initializeSocket(token);
            socketInitialized.current = true;
        } else if (!token && socketInitialized.current) {
            closeSocket();
            socketInitialized.current = false;
        }

        // Cleanup on unmount is tricky if we want to persist socket across navigations, 
        // usually App.js mounts once.
        return () => {
            // We usually don't close socket on App unmount unless the tab closes, 
            // but strict mode might trigger this. 
            // relying on token change to close is better.
        };
    }, [token]);
};

export default useSocketService;
